import { Component, Input } from '@angular/core';
import { ContactPerson } from '@dato-proxy/entities/contactperson.entity';
import { State } from '@dato-proxy/entities/state.entity';
import { BaseComponent } from '@m4u-angular/base/component/BaseComponent';
import { ServiceBagService } from '@m4u-angular/base/component/ServiceBag';
import { BaseState } from '@m4u-angular/base/entities/BaseEntities';

@Component({
  selector: 'app-contact-person-list',
  templateUrl: './contact-person-list.component.html',
  styleUrls: ['./contact-person-list.component.scss']
})
export class ContactPersonListComponent extends BaseComponent<BaseState> {
    @Input() DataSource: ContactPerson[];
    @Input() IsAllowEdit: boolean;

    constructor(A: ServiceBagService) {
        super(A, "ContactPersonListComponent", State);
    }

    override IsUseFinishCycleChangeDetection(): boolean { return false; }

    GetMenu(contactPerson: ContactPerson) {
        if (!this.IsAllowEdit) return [];
        return [{
            text: this.RC('lblEditContact'),
            icon: 'mdi mdi-pencil',
            onClick: () => this.OnEditContact(contactPerson.EntryID, 'edit')
        }];
    }

    OnEditContact(entryID, mode: 'new' | 'edit') {
        if (!this.IsAllowEdit) return;

        this.Navigate(['pages/contact-person', mode === 'new' ? 'new' : entryID]);
    }
}
